(function () {
  const root = document.querySelector('[data-inquiry-prefill]');
  if (!root) return;

  const urlParam = root.dataset.urlParam || 'product';
  const configuredSelector = root.dataset.fieldSelector;

  const productTitle = new URLSearchParams(window.location.search).get(urlParam);
  if (!productTitle) return;

  const FIELD_SELECTORS = [
    configuredSelector,
    '[data-testid="field-custom#product_name"]',
    '[id="custom#product_name"]',
    'input[aria-labelledby="label-custom#product_name"]',
  ].filter(Boolean);

  const banner = root.querySelector('[data-inquiry-banner]');
  const nameEl = root.querySelector('[data-inquiry-product-name]');

  if (banner && nameEl) {
    nameEl.textContent = productTitle;
    banner.hidden = false;
  }

  // Recursively search the light DOM and every open shadow root.
  function deepQuery(node, selectors) {
    if (!node) return null;

    for (const selector of selectors) {
      const direct = node.querySelector && node.querySelector(selector);
      if (direct) return direct;
    }

    const hosts = node.querySelectorAll ? node.querySelectorAll('*') : [];
    for (const host of hosts) {
      if (host.shadowRoot) {
        const found = deepQuery(host.shadowRoot, selectors);
        if (found) return found;
      }
    }

    return null;
  }

  // React tracks input values internally, so a plain assignment is ignored.
  function setReactValue(input, value) {
    const setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    )?.set;

    if (setter) {
      setter.call(input, value);
    } else {
      input.value = value;
    }

    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }

  function lockProductField() {
    const field = deepQuery(document, FIELD_SELECTORS);
    if (!field) return false;

    // Setting the value and dispatching input lets the form apply its own
    // filled-state label styling, so we leave the label positioning alone.
    setReactValue(field, productTitle);

    field.readOnly = true;
    field.setAttribute('readonly', 'readonly');
    field.setAttribute('aria-readonly', 'true');
    field.style.cursor = 'not-allowed';
    field.dataset.inquiryLocked = 'true';

    return true;
  }

  function init() {
    if (lockProductField()) return;

    const observer = new MutationObserver(() => {
      if (lockProductField()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const retry = setInterval(() => {
      if (lockProductField()) {
        clearInterval(retry);
        observer.disconnect();
      }
    }, 300);

    setTimeout(() => {
      clearInterval(retry);
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
